module.exports = __webpack_public_path__ + "img/logo.6b8800c4.png";